import { nursePortrait1, nursePortrait2, nursePortrait3 } from '../content/landingContentShared.js';
import type { LandingMatchingContent } from '../content/landingMatchingContent.js';

const previousPortraits: Readonly<Record<string, string>> = {
  'demo-aylin': nursePortrait1,
  'demo-emre': nursePortrait2,
  'demo-selin': nursePortrait3,
  'demo-mehmet': nursePortrait2,
  'demo-zeynep': nursePortrait1,
  'demo-deniz': nursePortrait3,
};

/** Refresh only the shipped demo placeholders. Preserve uploaded images and edited identities. */
export const refreshMatchingDemoPortraits = (matching: LandingMatchingContent, fallback: LandingMatchingContent): void => {
  const defaults = new Map(fallback.candidates.map(candidate => [candidate.id, candidate]));
  for (const candidate of matching.candidates) {
    const previousImage = previousPortraits[candidate.id];
    const original = defaults.get(candidate.id);
    if (
      previousImage && original &&
      candidate.profileImageUrl === previousImage &&
      candidate.firstName === original.firstName && candidate.age === original.age
    ) candidate.profileImageUrl = original.profileImageUrl;
  }
};
